import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import configData from "../config";
import { axiosSetting, showToast } from "../libs/utils";
import MiddleContent from "./MiddleContent";
import DeclineConfirmModel from "./DeclineConfirmModel";
import CheckoutPaymentModel from "./CheckoutPaymentModel";
import Footer from "./Footer";
import AskQuestionButton from "./AskQuestionButton";
import { useAppContext } from "../libs/contextLib";

export const PageLayout = ({
  salesData,
  setSalesData,
  setPaymentLoading,
  offerCode,
  reloadOfferCode,
  isDataLoading,
  setIsDataLoading,
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const logo =
    "https://myprotectall.com/wp-content/uploads/2023/09/PA-Logo-Horizonal-Blue.png";

  const [totalPrice, setTotalPrice] = useState(0);
  const [products, setProduct] = useState([]);
  const [show, setShow] = useState(false); // model show hide
  const [showDeclineModel, setShowDeclineModel] = useState(false); // decline model show hide
  const [offInputCode, setOffInputCode] = useState(""); // decline model show hide
  const navigate = useNavigate();
  const inputRef = useRef();
  const axiosCall = axiosSetting(offerCode);
  const { configureData } = useAppContext();

  const config = {
    logo: configureData.theme?.logo || logo,
    color: configureData.theme?.primaryColor || "black",
    textColor: configureData.theme?.textColor || "white",
  };

  let logoRedirectUrl = configureData.theme?.logoRedirectUrl;
  if (logoRedirectUrl && !/^https?:\/\//i.test(logoRedirectUrl)) {
    logoRedirectUrl = `https://${logoRedirectUrl}`;
  }
  useEffect(() => {
    if (salesData && !salesData.isValid && !isDataLoading) {
      inputRef.current?.focus();
    }
  }, [isDataLoading, salesData]);

  useEffect(() => {
    (async function () {
      try {
        const newSelectedItems = [];

        if (salesData?.data?.protections) {
          salesData.data.protections = salesData.data.protections.map(
            (item) => ({
              ...item,
              is_checked: false, // ensure no checkbox is selected by default
            })
          );
        }

        setSelectedItems(newSelectedItems);
      } catch (e) {
        console.error("error whhile setting items selected:::", e);
      }
    })();
  }, [salesData, isDataLoading]);

  // fill and updated array with selectes/checked protections list.
  const onSelectItemClick = (event, item) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Deselect all other protections
      const updatedProtections = salesData.data.protections.map(
        (planGroup) => ({
          ...planGroup,
          plans: planGroup.plans.map((plan) => ({
            ...plan,
            is_checked:
              plan.plan_type === item.plan_type
                ? plan.product_id === item.product_id // only one per group
                : plan.is_checked, // leave other groups as they are
          })),
        })
      );

      setSelectedItems((prev) => {
        // replace or add this selection for its group
        const filtered = prev.filter((sel) => sel.plan_type !== item.plan_type);
        return [
          ...filtered,
          {
            item: item.name,
            model_number: item.model_number,
            price: item.price,
            product_id: item.product_id,
            quantity: item.quantity,
            plan_type: item.plan_type,
          },
        ];
      });

      // Update the salesData reference if needed
      salesData.data.protections = updatedProtections;
    } else {
      // If unchecked, clear selection
      const updatedProtections = salesData.data.protections.map(
        (planGroup) => ({
          ...planGroup,
          plans: planGroup.plans.map((plan) => ({
            ...plan,
            is_checked:
              plan.product_id === item.product_id ? false : plan.is_checked,
          })),
        })
      );

      setSelectedItems((prev) =>
        prev.filter((sel) => sel.product_id !== item.product_id)
      );
      salesData.data.protections = updatedProtections;
    }
  };
  // show model confirm payment list
  const onClickProceedCheckout = async () => {
    if (selectedItems && selectedItems.length > 0) {
      const items = [];
      const total = selectedItems.reduce((tot, itm) => {
        items.push({ name: itm.item, product_id: itm.product_id });
        return tot + itm.price;
      }, 0);
      setTotalPrice(Number(total.toFixed(4)));
      setProduct(items);
      setShow(true);
      await axiosCall.post(configData.saveActivity, {
        activity: "STRIPE_BUTTON_CLICK",
      });
    } else {
      showToast("error", "Please select at least one protection plan");
    }
  };
  // send api call to payment checkout.
  async function handleToken(token, addresses) {
    try {
      setPaymentLoading(true);
      const response = await axiosCall.post(configData.stripeCheckoutApi, {
        token,
        products,
        email: salesData.data.email,
      });
      console.log("response::::", response);
      if (response && response.status && response.status === 200) {
        let resData = response["data"];
        let paymentStatus = resData.paymentStatus;
        handleClose();
        if (paymentStatus) {
          showToast("success", "Your payment completed Successfully.");
          navigate("/success");
        } else {
          showToast(
            "error",
            resData.message +
              ". We were unable to process your payment. Please try again, try a different payment method, or contact us if you continue to have issues."
          );
        }
      } else {
        showToast(
          "error",
          "We were unable to process your payment. Please try again, try a different payment method, or contact us if you continue to have issues."
        );
        handleClose();
      }
    } catch (err) {
      console.log("catch error : ", err);
      showToast(
        "error",
        "We were unable to process your payment. Please try again, try a different payment method, or contact us if you continue to have issues."
      );
      handleClose();
    }
  }
  // close model and reset state
  const handleClose = () => {
    setShow(false);
    setTotalPrice(0);
    setProduct([]);

    setIsDataLoading(false);
    setPaymentLoading(false);
  };
  // show/open decline model
  const handleShowDecline = () => {
    setShowDeclineModel(true);
  };
  // close decline model
  const handleCloseDecline = () => {
    setShowDeclineModel(false);
  };
  // confirm api
  const handleConfirmDecline = async () => {
    if (salesData && salesData.data.email) {
      setIsDataLoading(true);
      const axiosCall = axiosSetting(offerCode);
      const response = await axiosCall.post(configData.declineCoverage, {
        email: salesData.data.email,
      });
      if (response && response.status && response.status === 200) {
        handleCloseDecline();
        showToast("success", "You have successfully declined all coverage.");
        setSalesData([]);
        setIsDataLoading(false);
      } else {
        showToast("error", "Decline coverage failed.");
        handleCloseDecline();
        setIsDataLoading(false);
      }
    } else {
      showToast("error", "Email id not found.");
    }
  };

  // get data from input offer code
  const getDataFromOfferCode = () => {
    if (offInputCode && offInputCode.trim() !== "") {
      reloadOfferCode(offInputCode);
      window.location = `/${offInputCode}`;
    } else {
      showToast("error", "Please enter the offer code.");
    }
  };

  return (
    <div className="pagebody">
      <div
        className="banner-part"
        style={{
          backgroundImage: configureData.theme?.backgroundImage
            ? `url(${configureData.theme?.backgroundImage})`
            : "none",
        }}
      >
        <div className="container">
          <div
            className="col-12 d-flex justify-content-between align-items-center flex-wrap"
            style={{ rowGap: "8px" }}
          >
            <div
              style={{ height: "70px", maxWidth: "260px" }}
              className="d-flex align-items-center"
            >
              <a
                href={logoRedirectUrl || "/"}
                target={logoRedirectUrl ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                <img
                  src={config.logo}
                  alt="logo"
                  style={{ maxHeight: "100%", maxWidth: "100%" }}
                />
              </a>
            </div>
            <h2 className="mb-0">
              Welcome to the family
              {salesData && salesData?.data?.fname
                ? ", " + salesData?.data?.fname + "!"
                : "."}
            </h2>
          </div>
        </div>
        <div
          className="homebannersection"
          style={{
            flex: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="container">
            {salesData ? (
              salesData.isValid && !salesData.isExpired ? (
                salesData.isPurchased ? (
                  <div className="col-md-12 text-center">
                    <div className="text-center mb-3 align-items-center d-sm-flex justify-content-center">
                      <h3 className="mb-0 text-uppercase">
                        The offer code has already been used.
                      </h3>
                    </div>
                    <p>
                      Thank you for your interest in purchasing the protection
                      plan. The offer code has already been used.
                      {configureData.theme?.helpLineNumber &&
                        ` If you need a new offer code or have any questions, please use the Contact Us button on the lower part of the screen or call us at ${configureData.theme?.helpLineNumber}`}
                    </p>
                  </div>
                ) : salesData.isOptOut ? (
                  <div className="col-md-12 text-center">
                    <div className="text-center mb-3 align-items-center d-sm-flex justify-content-center">
                      <h3 className="mb-0 text-uppercase">Opted Out</h3>
                    </div>
                    <p>
                      If you have opted out in error, feel free to contact using
                      the text messaging in the lower right of the screen
                      {configureData.theme?.helpLineNumber &&
                        ` or call us at ${configureData.theme?.helpLineNumber}`}
                    </p>
                  </div>
                ) : (
                  <div className="row m-0">
                    <div className="col-md-12">
                      <div className="text-center mb-2 hs-plan-content">
                        <h3 className="h3_title">
                          Protection Options for:{" "}
                          {(salesData && salesData?.data?.fname
                            ? salesData?.data?.fname
                            : "") +
                            " " +
                            (salesData && salesData?.data?.lname
                              ? salesData?.data?.lname
                              : "")}
                        </h3>

                        <div className="text-center">
                          Invoice #{salesData && salesData.data?.invoice_no}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9 mx-auto">
                      <div className="table-responsive mt-4">
                        {salesData &&
                          salesData.data.protections &&
                          salesData.data.protections.map((planData, idx) => (
                            <div key={idx}>
                              <h3 className="plan-type-title">
                                {`${planData?.plan_type} - ${planData?.model_number} `}
                                :
                              </h3>
                              <table className="table no-border pricmgtable mb-4">
                                <tbody>
                                  {planData.plans
                                    .sort((a, b) => +b.price - +a.price)
                                    .map((item, i) => (
                                      <tr key={i}>
                                        <td>
                                          <div className="form-check">
                                            <label className="form-check-label font18 d-flex align-items-center user-select-none">
                                              <input
                                                type="checkbox"
                                                value={item.product_id}
                                                onChange={(e) =>
                                                  onSelectItemClick(e, item)
                                                }
                                                checked={item.is_checked}
                                              />
                                              <p className="ml-2 m-0">
                                                {item.name}:
                                              </p>
                                            </label>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="prices">
                                            {item.price
                                              ? `$${item.price}`
                                              : "N/A"}
                                          </div>
                                        </td>
                                        {item?.learn_more_link && (
                                          <td style={{ width: "150px" }}>
                                            <a
                                              href={item.learn_more_link}
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                background: config?.color,
                                                borderColor: config?.color,
                                                color: config?.textColor,
                                              }}
                                              className="btn"
                                            >
                                              {" "}
                                              Learn More{" "}
                                            </a>
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          ))}
                      </div>
                      <div className="text-center mt-5">
                        <p>
                          Some items from your invoice may not be eligible for
                          coverage. Please reference the <br />
                          Terms and Conditions of your plan for coverage and
                          exclusion information.
                        </p>
                      </div>
                      <div className="text-center mt-5 procdedbtn">
                        <span
                          style={{
                            background: config?.color,
                            borderColor: config?.color,
                            color: config?.textColor,
                            opacity: selectedItems.length === 0 ? 0.5 : 1,
                          }}
                          className={`btn text-uppercase font-weight-bold ${
                            selectedItems.length === 0
                              ? "disabled-cursor"
                              : "pointer"
                          }`}
                          onClick={
                            selectedItems.length >= 1
                              ? onClickProceedCheckout
                              : undefined
                          }
                        >
                          {" "}
                          Proceed to checkout{" "}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-12 text-center mt-5">
                      <p className="mb-0">
                        <span
                          className="coveregelink"
                          onClick={handleShowDecline}
                        >
                          {" "}
                          Click HERE to decline all coverages.{" "}
                        </span>
                      </p>
                    </div>
                  </div>
                )
              ) : (
                <div className="row m-0">
                  {!isDataLoading && (
                    <>
                      <div className="col-md-12 text-center">
                        <div className="text-center mb-3 align-items-center d-sm-flex justify-content-center">
                          <h5 className="mb-2">
                            We are sorry we don't recognize your offer code.
                          </h5>
                        </div>
                        <span className="font18">
                          Please re-enter code below
                          {configureData.theme?.helpLineNumber &&
                            ` or contact us at ${configureData.theme?.helpLineNumber}`}
                        </span>
                      </div>
                      <div className="col-md-4 mx-auto">
                        <div className="text-center mt-4 procdedbtn">
                          <input
                            type="text"
                            placeholder="Enter Code"
                            className="form-control"
                            value={offInputCode}
                            onKeyDown={(e) =>
                              e.key === "Enter" && getDataFromOfferCode()
                            }
                            onChange={(e) => setOffInputCode(e.target.value)}
                            style={{ marginRight: 15 }}
                            ref={inputRef}
                          />
                          <button
                            style={{
                              background: config?.color,
                              borderColor: config?.color,
                              color: config?.textColor,
                            }}
                            className="btn mt-3 btn-block text-uppercase font-weight-bold"
                            onClick={getDataFromOfferCode}
                          >
                            Reveal offer(s)
                          </button>
                        </div>
                      </div>
                      {configureData.theme?.helpLineNumber && (
                        <>
                          <div className="col-md-12 text-center mt-5">
                            <p>
                              <a
                                href={`tel:${configureData.theme?.helpLineNumber}`}
                                className="coveregelink"
                              >
                                Having trouble with your code? Give us a call at{" "}
                                {configureData.theme?.helpLineNumber} for
                                assistance.
                              </a>
                            </p>
                          </div>{" "}
                        </>
                      )}
                    </>
                  )}
                </div>
              )
            ) : (
              <div className="row m-0">
                {!isDataLoading && (
                  <>
                    <div className="col-md-12 text-center">
                      <div className="text-center mb-3 align-items-center d-sm-flex justify-content-center">
                        <h3 className="mb-0 text-uppercase">
                          Ready to secure your investment?
                        </h3>
                      </div>
                      <p>
                        Please enter your special invitation code here for your
                        plan options:
                      </p>
                    </div>
                    <div className="col-md-4 mx-auto">
                      <div className="text-center mt-4 procdedbtn">
                        <input
                          type="text"
                          placeholder="Enter Code"
                          className="form-control"
                          value={offInputCode}
                          onKeyDown={(e) =>
                            e.key === "Enter" && getDataFromOfferCode()
                          }
                          onChange={(e) => setOffInputCode(e.target.value)}
                          style={{ marginRight: 15 }}
                          ref={inputRef}
                        />
                        <button
                          style={{
                            background: config?.color,
                            borderColor: config?.color,
                            color: config?.textColor,
                          }}
                          className="btn mt-3 btn-block text-uppercase font-weight-bold"
                          onClick={getDataFromOfferCode}
                        >
                          Reveal offer(s)
                        </button>
                      </div>
                    </div>
                    {configureData.theme?.helpLineNumber && (
                      <>
                        <div className="col-md-12 text-center mt-5">
                          <p>
                            <a
                              href={`tel:${configureData.theme?.helpLineNumber}`}
                              className="coveregelink"
                            >
                              Having trouble with your code? Give us a call at{" "}
                              {configureData.theme?.helpLineNumber} for
                              assistance.
                            </a>
                          </p>
                        </div>{" "}
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <MiddleContent />
      {configureData.theme?.brandVideoUrl && (
        <div className="protection-option">
          <div className="container">
            <div className="row m-0 align-items-center">
              <div className="col-md-6">
                <div className="">
                  <video
                    controls
                    className="embed-responsive"
                    style={{ aspectRatio: 16 / 9 }}
                  >
                    <source
                      src={configureData.theme?.brandVideoUrl}
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
              <div className="col-md-6">
                <div className="bannertexts">
                  <h3>BREAKDOWNS HAPPEN</h3>
                  <h5 className="mt-3">
                    Now is the time to protect your beautiful new product from
                    breakdowns and avoid expensive replacement costs in the
                    future!
                  </h5>
                  <p className="mt-3">
                    Experience the freedom to enjoy your product... worry-free!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <AskQuestionButton salesData={salesData} config={config} />
      {/* final Confirm payment Model */}
      <CheckoutPaymentModel
        show={show}
        logoUrl={config.logo}
        logoRedirectUrl={logoRedirectUrl}
        handleClose={handleClose}
        selectedItems={selectedItems}
        totalPrice={totalPrice}
        isLoading={isDataLoading}
        handleToken={handleToken}
      />

      {/* confirm model */}
      <DeclineConfirmModel
        logoUrl={config.logo}
        logoRedirectUrl={logoRedirectUrl}
        showDeclineModel={showDeclineModel}
        handleConfirmDecline={handleConfirmDecline}
        handleCloseDecline={handleCloseDecline}
      />
      {configureData.theme?.helpLineNumber && (
        <Footer configureData={configureData} />
      )}
    </div>
  );
};
